import * as firebase from 'firebase';
import * as firebaseui from "firebaseui";
import 'firebase/firestore';

const config = {
  apiKey: "AIzaSyDYBM_H1o7sTCVusfcSAGd57de6ZLkQlc4",
  authDomain: "rssgarden-e82ba.firebaseapp.com",
  databaseURL: "https://rssgarden-e82ba.firebaseio.com",
  projectId: "rssgarden-e82ba",
  storageBucket: "rssgarden-e82ba.appspot.com",
  messagingSenderId: "57033543668"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const firestoreSettings = { timestampsInSnapshots: true };

export const db = firebase.firestore();

db.settings(firestoreSettings);

export const auth = firebase.auth();
const authUI = new firebaseui.auth.AuthUI(auth);

export const startAuthUI = (div, onSignIn) => {
  const uiConfig = {
    'signInSuccessUrl': `${process.env.PUBLIC_URL}`,
    'callbacks': {
      'signInSuccess': (user) => {
        if (onSignIn) {
          onSignIn(user);
        }
        return false;
      }
    },
    'signInOptions': [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ]
  }

  authUI.start('#firebaseui-auth', uiConfig);
}

export const resetAuthUI = () => {
  authUI.reset();
}




// WEBPACK FOOTER //
// ./src/data/firebase.js